import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const ExclamationIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2 12C2 17.5231 6.47686 22 12 22C17.5231 22 22 17.5231 22 12C22 10.3018 21.5754 8.66263 20.7776 7.20494C20.1644 6.08552 19.3411 5.092 18.3553 4.27837C16.5772 2.81451 14.3501 2 12 2C6.47686 2 2 6.47686 2 12ZM21 12C21 16.9709 16.9709 21 12 21C7.02914 21 3 16.9709 3 12C3 7.02914 7.02914 3 12 3C14.1159 3 16.1189 3.73254 17.7192 5.05001C18.607 5.78267 19.3485 6.67757 19.9005 7.6852C20.6182 8.99646 21 10.4707 21 12ZM12.5 13.5259L12.5 7.47413C12.5 7.21227 12.2761 7 12 7C11.7239 7 11.5 7.21227 11.5 7.47413L11.5 13.5259C11.5 13.7877 11.7239 14 12 14C12.2761 14 12.5 13.7877 12.5 13.5259ZM12 16.7793C11.633 16.7793 11.335 16.4813 11.335 16.1143C11.335 15.7473 11.633 15.4493 12 15.4493C12.367 15.4493 12.665 15.7473 12.665 16.1143C12.665 16.4813 12.367 16.7793 12 16.7793Z'
      />
    </svg>
  );
};
